<div *ngIf="sessionData" class="ChangeTimezone">
  <div class="ChangeTimezone-header d-flex flex-row justify-content-between">
    <h4 class="title__page">Select TimeZone</h4>
    <app-button
      size="small"
      text="Back to Inbox"
      route="/messages"
      [style]="'outline'"
      color="blue"></app-button>
  </div>
  <div class="ChangeTimezone-form container">
    <form [formGroup]="formGroup">
      <div class="ChangeTimezone-form-row">
        <div class="ChangeTimezone-form-label col col-12 col-md-6">
          <p class="mb-0">Select time zone:</p>
        </div>
        <div class="col col-12 col-md-6">
          <app-select
            [items]="timezones"
            [label]="'Select your timezone'"
            formControlName="timezone"></app-select>
          <mat-checkbox class="mt-3" formControlName="observe_dst"
            >Select to Observe DST</mat-checkbox
          >
        </div>
      </div>
      <div class="d-flex flex-row justify-content-between mt-5">
        <app-button
          class="ChangeTimezone-form-button"
          [style]="cancelButtonProperties.style"
          [size]="cancelButtonProperties.size"
          [color]="cancelButtonProperties.color"
          [route]="cancelButtonProperties.route"
          [text]="cancelButtonProperties.text"></app-button>
        <app-button
          class="ChangeTimezone-form-button"
          [style]="continueButtonProperties.style"
          [size]="continueButtonProperties.size"
          [color]="continueButtonProperties.color"
          [text]="continueButtonProperties.text"
          [observeApi]="true"
          [Click]="continueButtonProperties.onClick"></app-button>
      </div>
    </form>
  </div>
</div>
